import React, { createContext, useContext, useState } from 'react';

import { ApiConfiguration, LatLongRequest, ProductsApi } from '../../apis';
import useGeoLocation from '../../hooks/useGeoLocation';

export const SmartyContext = createContext<undefined | any>(null);

const Provider = SmartyContext.Provider;

interface Props {
  children: React.ReactNode;
}

export function SmartyProvider({ children }: Props) {
  const location = useGeoLocation();

  const [smartyData, setSmartyData] = useState<undefined | any>({
    loaded: false,
    location: null,
  });
  React.useEffect(() => {
    if (location.loaded) {
      const api = new ProductsApi(
        new ApiConfiguration({
          basePath: process.env.GATSBY_PUBLIC_API_PATH,
        }),
      );

      api
        .productsLatLongPost({
          latLongRequest: {
            latitude: Number(location?.coordinates.lat),
            longitude: Number(location?.coordinates.long),
          },
        })
        .then((response: LatLongRequest) => {
          setSmartyData({ loaded: true, location: response });
          sessionStorage.smartyState = response;
        })
        .catch((error) => console.error('Error:', error));
    }
    return () => {};
  }, [location]);

  return <Provider value={smartyData}>{children}</Provider>;
}

export function useSmartyContext() {
  const context = useContext(SmartyContext);
  if (context === undefined) {
    throw new Error('useSmartyContext should be used within a SmartyProvider');
  }

  return context;
}
